import i18n, { TFunction } from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { logging } from '@/services/logging';

export const STATIC_SUPPORTED_LANGUAGES = Object.freeze(['en', 'uk', 'es', 'fr', 'pt', 'ru', 'it', 'de'] as const);
const DEFAULT_SUPPORTED_LANGUAGES = [STATIC_SUPPORTED_LANGUAGES[0]];

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next);

const syncDocumentLanguage = (lng: string) => {
  if (typeof document === 'undefined') {
    return;
  }
  document.documentElement.lang = lng;
  document.documentElement.setAttribute('translate', 'no');
};

i18n.on('languageChanged', syncDocumentLanguage);
i18n.on('initialized', () => {
  if (i18n.language) {
    syncDocumentLanguage(i18n.language);
  }
});

if (typeof window !== 'undefined') {
  // TEMP: expose i18n for console debugging
  (window as typeof window & { __appI18n?: typeof i18n }).__appI18n = i18n;
}

i18n.on('failedLoading', (lng, ns, msg) => {
  logging.warn('i18n.failed_loading', { lng, ns, msg });
});

i18n.on('missingKey', (lngs, ns, key) => {
  logging.warn('i18n.missing_key', { lngs, ns, key });
});

// ... (rest of the file)

export const configureSupportedLanguages = (locales: ReadonlyArray<string>): Promise<TFunction> => {
  const normalized = Array.from(new Set([DEFAULT_SUPPORTED_LANGUAGES[0], ...locales]));

  return i18n.init({
    fallbackLng: 'en',
    supportedLngs: normalized,
    ns: ['translation', 'oferta'],
    defaultNS: 'translation',
    fallbackNS: 'translation',
    debug: false,
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['cookie', 'localStorage'],
    },
    react: {
      useSuspense: true,
    },
  });
};

export default i18n;
